import * as React from 'react';
import * as styles from './ProgressBar.css';
import { ProgressBarItem } from './progressItem/ProgressItem';
import { inject, observer } from 'mobx-react';
import { ContentOrganizerStore } from '../stores';
import { REMOVE_FROM_TABORDER } from '../../../global/Constants';
import { LocalizationService } from "./../../../services/LocalizationService";
const ProgressBarContent = require('./progressBar.json');
const ProgressBarEditModeContent = require('./progressBarEditMode.json');

export interface IProgressBarProps {
  contentOrganizerStore?: ContentOrganizerStore;
  selectedStep: number;
  isEditMode: boolean;
  onSelectedStep: (step) => void;
}

export interface IProgressBarState {
  selectedStep: number;
}

@inject('contentOrganizerStore')
@observer
export class ProgressBar extends React.Component<IProgressBarProps, IProgressBarState>{

  constructor(props: IProgressBarProps) {
    super(props);
    this.state = {   
      selectedStep: this.props.contentOrganizerStore.selectedStep
    };
  }

  render() {
    console.log(this.props.contentOrganizerStore?.selectedStep);
    let progressBarItems: JSX.Element[] = [];
    (this.props.isEditMode ? ProgressBarEditModeContent : ProgressBarContent).forEach((progressBarItem: { title: string, key: string, step: number }) => {
      progressBarItems.push(
        <ProgressBarItem
          contentOrganizerStore={this.props.contentOrganizerStore ? this.props.contentOrganizerStore : undefined}
          key={`progressBarItem_${progressBarItem.key}`}
          title={progressBarItem ? new LocalizationService().strings[`ContentOrganizer_${progressBarItem.title}`] : undefined}
          selected={this.state.selectedStep === progressBarItem.step}
          step={progressBarItem.step}
          onSelectedStep={(step) => {
            this.props.onSelectedStep(step);               
          }}
          onClick={() => {
            this.props.contentOrganizerStore.setStep(progressBarItem.step);
          }}
        />
      );
    });
    return (
      <div 
        tabIndex={REMOVE_FROM_TABORDER}
        className={styles.progressBar}
      >
        {progressBarItems}
      </div>
    );
  }
}